import { Button, Form, Input, message } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import AuthContainer from "./AuthContainer";
import {
  FormItemRequiredRule,
  UserPasswordRequiredRule,
} from "Utility/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

export const ResetPassword = () => {
  const [form] = Form.useForm();
  const [isLoading, setisLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [defaultCode, setDefaultCode] = useState("");
  const [defaultMail, setDefaultMail] = useState("");

  useEffect(() => {
    const code = location?.search?.split("code=")?.[1]?.split("+email=")?.[0];
    let email = location?.search?.split("email=")?.[1];
    if (code) {
      setDefaultCode(code);
      form.setFieldsValue({ code }); // Set the initial value for the code field
    }
    if (email) {
      setDefaultMail(email);
    }
  }, [location, form]);

  const handleNewPassword = (data) => {
    const code = data?.code || defaultCode;
    const email = location?.state?.email || defaultMail;
    forgotPasswordSubmit(email, code, data?.password);
  };

  async function forgotPasswordSubmit(username, code, newPassword) {
    setisLoading(true);
    try {
      await Auth.forgotPasswordSubmit(username, code, newPassword);
      message.success("Your password has been successfully reset");
      navigate("/login");
    } catch (err) {
      message.error(err?.message);
    } finally {
      setisLoading(false);
    }
  }

  return (
    <AuthContainer type={"set-password"}>
      <Form
        onFinish={handleNewPassword}
        layout="vertical"
        requiredMark={false}
        form={form}
        name="set-password"
        initialValues={{ code: defaultCode }} // Set initial value for the code field
        className="space-y-6 login-register-form"
      >
        <Form.Item name={"code"} rules={[FormItemRequiredRule]}>
          <Input.OTP length={6} className="input-border" variant="filled" />
        </Form.Item>

        <Form.Item
          name={"password"}
          label="Enter New Password"
          rules={[FormItemRequiredRule, UserPasswordRequiredRule]}
        >
          <Input
            placeholder="Create a new password"
            className="p-2 rounded-md input-border"
          />
        </Form.Item>

        <Form.Item
          name={"repeat-password"}
          label="Repeat Password"
          rules={[
            FormItemRequiredRule,
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords must match."));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Repeat password"
            className="p-2 rounded-md input-border"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="w-full rounded-lg"
            loading={isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </AuthContainer>
  );
};
